import React from "react";
import {
  FaExclamationTriangle,
  FaInfoCircle,
  FaLightbulb,
  FaThumbsUp,
} from "react-icons/fa";

const GROUPS = [
  {
    kind: "risk",
    title: "Problems",
    icon: FaExclamationTriangle,
    empty: "No problems detected.",
  },
  {
    kind: "opportunity",
    title: "Opportunities",
    icon: FaLightbulb,
    empty: null,
  },
  { kind: "positive", title: "Going well", icon: FaThumbsUp, empty: null },
  {
    kind: "info",
    // Named for what it actually is. These describe gaps in OUR records, and
    // grouping them with the client's problems would have people chasing
    // customers over our own missing data.
    title: "Caveats in our data",
    icon: FaInfoCircle,
    empty: null,
  },
];

/**
 * The evidence behind a client's score, grouped by what the reader should do
 * with it. Every signal shows its own detail line, so nothing has to be taken
 * on faith.
 */
export function SignalList({ signals }) {
  const list = signals || [];

  return (
    <div className="ct-signals">
      {GROUPS.map((group) => {
        const items = list.filter((signal) => signal.kind === group.kind);
        if (!items.length && !group.empty) return null;
        const Icon = group.icon;

        return (
          <section key={group.kind} className={`ct-signal-group ct-signal-group--${group.kind}`}>
            <h5>
              <Icon aria-hidden="true" /> {group.title}
            </h5>
            {items.length === 0 ? (
              <p className="ct-signal-empty">{group.empty}</p>
            ) : (
              <ul>
                {items.map((signal) => (
                  <li key={signal.id} className={`ct-signal ct-signal--${signal.severity}`}>
                    <span className="ct-signal-label">{signal.label}</span>
                    <span className="ct-signal-detail">{signal.detail}</span>
                  </li>
                ))}
              </ul>
            )}
          </section>
        );
      })}
    </div>
  );
}
